import { s as subscribe, i as is_promise, n as noop } from "../../../../chunks/utils.js";
import { c as create_ssr_component, v as validate_component, e as escape, i as each, d as add_attribute } from "../../../../chunks/ssr.js";
import { B as Button } from "../../../../chunks/Button.js";
import { S as Spinner } from "../../../../chunks/Spinner.js";
import { H as Hr } from "../../../../chunks/Hr.js";
import { C as Card } from "../../../../chunks/Card.js";
import { L as Listgroup, a as ListgroupItem } from "../../../../chunks/Listgroup.js";
import { E as EmployeeAvatar } from "../../../../chunks/EmployeeAvatar.js";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime.js";
import "dayjs/locale/de.js";
import { p as page } from "../../../../chunks/stores.js";
import { u as user } from "../../../../chunks/auth.js";
import "../../../../chunks/api.js";
import "../../../../chunks/customer2.js";
import "../../../../chunks/customer.js";
import { e as employeeStatus } from "../../../../chunks/options.js";
import { M as Modal } from "../../../../chunks/Modal2.js";
import { w as writable } from "../../../../chunks/index2.js";
import { G as GlobalShortcuts } from "../../../../chunks/GlobalShortcuts.js";
const EmployeeTodos = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { hrTodos } = $$props;
  if ($$props.hrTodos === void 0 && $$bindings.hrTodos && hrTodos !== void 0) $$bindings.hrTodos(hrTodos);
  return `<div class="grid grid-cols-3 gap-3">${validate_component(Card, "Card").$$render(
    $$result,
    {
      class: "h-min",
      padding: "xl",
      size: "md"
    },
    {},
    {
      default: () => {
        return `<h5 class="text-center text-xl text-neutral-600 dark:text-white mb-5 -mt-2" data-svelte-h="svelte-1lhcyfb">Bewerber Erinnerungen</h5> ${hrTodos && hrTodos?.contractSignatures ? `${hrTodos.contractSignatures.waitingForEmployee?.length > 0 ? `<div class="max-h-[200px] overflow-y-auto">${validate_component(Listgroup, "Listgroup").$$render(
          $$result,
          {
            items: hrTodos.contractSignatures.waitingForEmployee,
            class: "border-0 dark:!bg-transparent"
          },
          {},
          {
            default: ({ item }) => {
              return `<div class="flex items-center space-x-4 rtl:space-x-reverse">${validate_component(EmployeeAvatar, "EmployeeAvatar").$$render($$result, { employee: item.contract.employee }, {}, {})} <div class="flex-1 min-w-0"><p class="text-sm font-medium text-gray-900 truncate dark:text-white"><a href="${"/employee/" + escape(item.contract.employee.uuid, true)}">${escape(item?.contract.employee.name)}</a></p> <p class="text-sm text-gray-500 truncate dark:text-gray-400" data-svelte-h="svelte-19a45rt">Erwarte Mitarbieterunterschrift</p></div></div>`;
            }
          }
        )}</div>` : ``}` : `${validate_component(Spinner, "Spinner").$$render($$result, {}, {}, {})}`}`;
      }
    }
  )} ${validate_component(Card, "Card").$$render(
    $$result,
    {
      class: "h-min",
      padding: "xl",
      size: "md"
    },
    {},
    {
      default: () => {
        return `<h5 class="text-center text-xl text-neutral-600 dark:text-white mb-5 -mt-2" data-svelte-h="svelte-1vef0v1">Mitarbeiter Erinnerungen</h5> ${hrTodos && hrTodos.contractSignatures?.waitingForHR?.length > 0 ? `<div class="max-h-[200px] overflow-y-auto">${validate_component(Listgroup, "Listgroup").$$render($$result, { class: "border-0 dark:!bg-transparent" }, {}, {
          default: () => {
            return `${each(hrTodos.contractSignatures.waitingForHR, (item, i) => {
              return `${validate_component(ListgroupItem, "ListgroupItem").$$render($$result, {}, {}, {
                default: () => {
                  return `<div class="flex items-center space-x-4 rtl:space-x-reverse">${validate_component(EmployeeAvatar, "EmployeeAvatar").$$render($$result, { employee: item.contract.employee }, {}, {})} <div class="flex-1 min-w-0"><p class="text-sm font-medium text-gray-900 truncate dark:text-white"><a href="${"/employee/" + escape(item.contract.employee.uuid, true)}">${escape(item?.contract.employee.name)}</a></p> <p class="text-sm text-gray-500 truncate dark:text-gray-400" data-svelte-h="svelte-v19bak">Erwarte HR-Unterschrift</p> </div></div> `;
                }
              })}`;
            })}`;
          }
        })}</div>` : ``}`;
      }
    }
  )} ${validate_component(Card, "Card").$$render(
    $$result,
    {
      class: "h-min",
      padding: "xl",
      size: "md"
    },
    {},
    {
      default: () => {
        return `<h5 class="text-center text-xl text-neutral-600 dark:text-white mb-5 -mt-2" data-svelte-h="svelte-6ujhho">Generelle Reminder</h5>`;
      }
    }
  )}</div>`;
});
const FullCalender = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  dayjs.extend(relativeTime);
  dayjs.locale("de");
  let calendarElement;
  let { calendar = null } = $$props;
  if ($$props.calendar === void 0 && $$bindings.calendar && calendar !== void 0) $$bindings.calendar(calendar);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `<div class="w-full h-min"${add_attribute("this", calendarElement, 0)}></div> ${``}`;
  } while (!$$settled);
  return $$rendered;
});
let template = { opened: 0, clicks: 0, bounces: 0, age: 0, results: [] };
if (typeof window !== "undefined" && sessionStorage.getItem("mailStatus")) {
  template = JSON.parse(sessionStorage.mailStatus);
}
const mailStatus = writable(template);
mailStatus.subscribe((val) => {
  if (typeof window !== "undefined") {
    sessionStorage.setItem("mailStatus", JSON.stringify(val));
  }
});
const MailjetStatus = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $mailStatus, $$unsubscribe_mailStatus;
  $$unsubscribe_mailStatus = subscribe(mailStatus, (value) => $mailStatus = value);
  let modalOpen = false;
  let statusData = $mailStatus;
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${`<div class="grid place-items-center">${validate_component(Spinner, "Spinner").$$render($$result, { size: "12" }, {}, {})}</div>`} ${validate_component(Modal, "Modal").$$render(
      $$result,
      { open: modalOpen },
      {
        open: ($$value) => {
          modalOpen = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `<h3 data-svelte-h="svelte-5zwsxb">Stats</h3> ${statusData ? `${each(statusData.results || [], (item) => {
            return `<div class="flex gap-3 justify-between"><span>${escape(dayjs(item["Timeslice"].split("T")[0]).format("DD.MM.YYYY"))} <br>Emails: ${escape(item["Total"])}</span> <div>Opened: ${escape(item["MessageOpenedCount"])} <br>Clicked: ${escape(item["MessageClickedCount"])}</div> <div>Blocked: ${escape(item["MessageBlockedCount"])} <br>Bounced: ${escape(item["MessageHardBouncedCount"])} <br>Spam: ${escape(item["MessageSpamCount"])}</div> </div>`;
          })}` : ``}`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_mailStatus();
  return $$rendered;
});
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $page, $$unsubscribe_page;
  let $user, $$unsubscribe_user;
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  $$unsubscribe_user = subscribe(user, (value) => $user = value);
  let hrTodos;
  $page.data.hrReminders;
  let calendar;
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${$$result.head += `<!-- HEAD_svelte-146bw2n_START -->${$$result.title = `<title>HR</title>`, ""}<!-- HEAD_svelte-146bw2n_END -->`, ""} ${validate_component(GlobalShortcuts, "GlobalShortcuts").$$render($$result, {}, {}, {})} <div class="w-full flex gap-3 place-items-center justify-center mt-5" data-svelte-h="svelte-b8ujf5"> <img src="/img/ci/recrew_black.svg" class="h-14" alt="bildmarke"></div> <h1 class="text-2xl leading-7 text-neutral-600 my-12 text-center">Welcome, ${escape($user?.associations[0]?.name || "Nutzer")}</h1> ${validate_component(Hr, "Hr").$$render($$result, {}, {}, {})} <h1 class="text-2xl leading-7 text-neutral-600 my-12" data-svelte-h="svelte-7ouf27">Recruiting Status</h1> <section class="flex flex-col gap-16"><div class="flex gap-8 flex-wrap flex-col lg:flex-row justify-between items-center">${$page.data.delayed ? `${function(__value) {
      if (is_promise(__value)) {
        __value.then(null, noop);
        return ` ${validate_component(Spinner, "Spinner").$$render($$result, {}, {}, {})} `;
      }
      return function(employeeCount) {
        return ` <div class="flex-1 grid grid-cols-5 gap-12">${each(
          Object.entries(employeeStatus).filter(([key]) => ![
            "active",
            "data-re-requested",
            "data-re-provided",
            "rebuddy",
            "inactive",
            "re-offered"
          ].includes(key)),
          ([key, name]) => {
            return `${key !== "onboarding" ? `<div class="flex items-center gap-3">${validate_component(Button, "Button").$$render(
              $$result,
              {
                size: "sm",
                href: "/employees/list?filter%5BemploymentStatus%5D=" + key,
                class: "w-12"
              },
              {},
              {
                default: () => {
                  return `${escape(employeeCount[key])} `;
                }
              }
            )} <span class="text-neutral-600 text-sm">${escape(name)}</span> </div>` : ``}`;
          }
        )}</div> `;
      }(__value);
    }($page.data.delayed.employeeCount)}` : ``}</div></section> ${validate_component(Hr, "Hr").$$render($$result, {}, {}, {})} <h1 class="text-2xl leading-7 text-neutral-600 my-12" data-svelte-h="svelte-1sikpu">Wiedereintritt Status</h1> <section class="flex flex-col gap-16"><div class="flex gap-8 flex-wrap flex-col lg:flex-row justify-between items-center">${$page.data.delayed ? `${function(__value) {
      if (is_promise(__value)) {
        __value.then(null, noop);
        return ` ${validate_component(Spinner, "Spinner").$$render($$result, {}, {}, {})} `;
      }
      return function(employeeCount) {
        return ` <div class="flex-1 grid grid-cols-5 gap-12">${each(["data-re-requested", "data-re-provided", "re-offered", "inactive"], (key) => {
          return `<div class="flex items-center gap-3">${validate_component(Button, "Button").$$render(
            $$result,
            {
              size: "sm",
              href: "/employees/list?filter%5BemploymentStatus%5D=" + key,
              class: "w-12"
            },
            {},
            {
              default: () => {
                return `${escape(employeeCount[key])} `;
              }
            }
          )} <span class="text-neutral-600 text-sm">${escape(employeeStatus[key])}</span> </div>`;
        })}</div> `;
      }(__value);
    }($page.data.delayed.employeeCount)}` : ``}</div></section> ${validate_component(Hr, "Hr").$$render($$result, {}, {}, {})} <h1 class="text-2xl leading-7 text-neutral-600 my-12" data-svelte-h="svelte-1nhkrst">Aktiver Mitarbeiter Status</h1> <section class="flex flex-col gap-16"><div class="flex gap-8 flex-wrap flex-col lg:flex-row justify-between items-center">${$page.data.delayed ? `${function(__value) {
      if (is_promise(__value)) {
        __value.then(null, noop);
        return ` ${validate_component(Spinner, "Spinner").$$render($$result, {}, {}, {})} `;
      }
      return function(employeeCount) {
        return ` <div class="flex-1 grid grid-cols-5 gap-12">${each(["rebuddy", "active"], (key) => {
          return `<div class="flex items-center gap-3">${validate_component(Button, "Button").$$render(
            $$result,
            {
              size: "sm",
              href: "/employees/list?filter%5BemploymentStatus%5D=" + key,
              class: "w-12"
            },
            {},
            {
              default: () => {
                return `${escape(employeeCount[key])} `;
              }
            }
          )} <span class="text-neutral-600 text-sm">${escape(employeeStatus[key])}</span> </div>`;
        })}</div> `;
      }(__value);
    }($page.data.delayed.employeeCount)}` : ``}</div></section> ${validate_component(Hr, "Hr").$$render($$result, {}, {}, {})} <h2 class="text-2xl leading-7 text-neutral-600 my-12" data-svelte-h="svelte-zurqut">Kalender</h2> ${validate_component(FullCalender, "FullCalender").$$render(
      $$result,
      { calendar },
      {
        calendar: ($$value) => {
          calendar = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${validate_component(Hr, "Hr").$$render($$result, {}, {}, {})} <h2 class="text-2xl leading-7 text-neutral-600 my-12" data-svelte-h="svelte-ir5ipe">Offene Erinnerungen</h2> ${validate_component(EmployeeTodos, "EmployeeTodos").$$render($$result, { hrTodos }, {}, {})} <h2 class="text-2xl leading-7 text-neutral-600 my-12" data-svelte-h="svelte-olvtdr">Mailjet Status</h2> <div class="w-full">${validate_component(MailjetStatus, "MailjetStatus").$$render($$result, {}, {}, {})}</div>`;
  } while (!$$settled);
  $$unsubscribe_page();
  $$unsubscribe_user();
  return $$rendered;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
